/** Stable feature names advertised in Gateway hello responses. */
export const GATEWAY_SERVER_CAPS = {
  AGENT_SESSION_ID_CREATE: "agent-session-id-create-v1",
  BOARD_WIDGET_PUT_CANVAS_DOC: "board-widget-put-canvas-doc",
  CHAT_SEND_ROUTING_CONTRACT: "chat-send-routing-contract",
  CONTROL_UI_BROWSER_FOCUS: "control-ui-browser-focus",
  GATEWAY_RESTART_TARGET_SAFE: "gateway-restart-target-safe-v1",
  LOCAL_STATE_OWNER_ROUTING: "local-state-owner-routing-v1",
  MODELS_AUTH_SET_API_KEY_OWNER: "models-auth-set-api-key-owner-v1",
  MODELS_AUTH_LOGIN_OWNER: "models-auth-login-owner-v1",
  CHANNELS_PAIRING_LIST_OWNER: "channels-pairing-list-owner-v1",
  CHANNELS_PAIRING_APPROVE_OWNER: "channels-pairing-approve-owner-v1",
  EXEC_APPROVALS_GET_OWNER: "exec-approvals-get-owner-v1",
  EXEC_APPROVALS_SET_OWNER: "exec-approvals-set-owner-v1",
  EXEC_APPROVALS_NATIVE_COMMIT: "exec-approvals-native-commit-v1",
  WORKTREES_REMOVE_OWNER: "worktrees-remove-owner-v1",
  WORKTREES_RESTORE_OWNER: "worktrees-restore-owner-v1",
  WORKTREES_GC_OWNER: "worktrees-gc-owner-v1",
  WORKTREES_RECOVER_REMOVAL_OWNER: "worktrees-recover-removal-owner-v1",
  WORKTREES_RETIRE_SNAPSHOT_OWNER: "worktrees-retire-snapshot-owner-v1",
  MODEL_CATALOG_SNAPSHOT: "model-catalog-snapshot",
  NODE_PERMISSION_ERRORS: "node-permission-errors",
  NODE_WORKER_BUNDLE_PREFETCH: "node-worker-bundle-prefetch-v1",
  NODE_WORKER_BUNDLE_RETENTION: "node-worker-bundle-retention-v1",
  NODE_WORKER_BUNDLE_STATUS: "node-worker-bundle-status-v1",
  NODE_WORKER_CAPTURED_EXEC_POLICY: "node-worker-captured-exec-policy",
  NODE_WORKER_WORKSPACE_RESULT: "node-worker-workspace-result-v2",
  NODE_WORKER_WORKSPACE_QUIESCENCE: "node-worker-workspace-quiescence-v1",
  NODE_WORKER_DEVICE_FOLDERS: "node-worker-device-folders-v1",
  NODE_WORKER_ENVIRONMENT_SESSION: "node-worker-environment-session-v1",
  NODE_WORKER_HOST_DIAGNOSTICS: "node-worker-host-diagnostics-v1",
  NODE_WORKER_IDLE_RETENTION: "node-worker-idle-retention-v1",
  NODE_WORKER_LAUNCH_TOOL_NAMES: "node-worker-launch-tool-names-v1",
  NODE_WORKER_NATIVE_INFERENCE: "node-worker-native-inference-v1",
  NODE_WORKER_PORTAL_STREAM: "node-worker-portal-stream-v1",
  NODE_WORKER_PROMPT_CONTEXT: "node-worker-prompt-context-v1",
  NODE_WORKER_STATUS_WAIT: "node-worker-status-wait-v1",
  PUBLISHED_MODEL_CATALOG: "published-model-catalog",
  PROFILE_BINDING: "profile-binding-v1",
  PROGRESS_CARD_AGENT_SCOPE: "progress-card-agent-scope-v1",
  SESSION_SCOPED_CHAT_METADATA: "session-scoped-chat-metadata",
  SESSION_SCOPED_MODEL_CATALOG: "session-scoped-model-catalog",
  SESSION_UNREAD_ACK_CONTRACT: "session-unread-ack-contract",
  SESSION_GOAL_START: "session-goal-start-v1",
  SESSION_SETTINGS_CONTRACT: "session-settings-contract",
  SESSION_SETTINGS_CAS: "session-settings-cas-v1",
  SENDER_RESTRICTED_HIDDEN_HELPERS: "sender-restricted-hidden-helpers-v1",
  SYSTEM_AGENT_WIZARD_CANCEL: "openclaw-chat-wizard-cancel",
  SYSTEM_AGENT_SETUP_MODEL_REF: "openclaw-setup-model-ref",
  TASK_SUGGESTIONS_ACCEPT_MODES: "taskSuggestions.acceptModes",
  TALK_SESSION_CLOSE_DISPOSITION: "talk-session-close-disposition",
} as const;
